import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import MaterialIcon from '../Icon/MaterialIcon';
import s from './EmptyMessage.module.scss';

interface EmptyMessageProps {
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  iconName?: string;
  iconColor?: string;
  title?: string;
  body?: React.ReactNode;
  action?: React.ReactNode;
  border?: boolean;
  titleStyle?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
}

function EmptyMessage({
  style,
  icon,
  iconName,
  iconColor,
  title,
  body,
  action,
  border = true,
  titleStyle,
  bodyStyle,
}: EmptyMessageProps) {
  return (
    <div style={style} className={cx(s.root, { [s.border]: border })}>
      {iconName ? <MaterialIcon className={s.icon} icon={iconName} color={iconColor} /> : icon}
      {title && (
        <h3 className={s.title} style={titleStyle}>
          {title}
        </h3>
      )}
      {body && (
        <div className={s.body} style={bodyStyle}>
          {body}
        </div>
      )}
      {action}
    </div>
  );
}

EmptyMessage.propTypes = {
  body: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  action: PropTypes.element,
  icon: PropTypes.element,
  iconName: PropTypes.string,
  title: PropTypes.string,
  border: PropTypes.bool,
};

export default EmptyMessage;
